import Api from './Api'
import { PrescriptionResponseInterface } from '../../interfaces'
import {
  PrescriptionEditInterface,
  PrescriptionSendInterface,
} from '../../interfaces/PrescriptionInterface'
import { DataTableColumns } from 'interfaces/DataTableColumns'
import { PrescriptionResponseStateEnum } from 'enum'
import { errorHandler } from 'utils'

class Prescription extends Api {
  readonly urls = {
    getList: '/Prescription/GetPrescriptionForPharmacy',
    save: '/Prescription/SavePharmacyResponse',
    getPrescriptionOfUser: '/Prescription/GetPrescriptionOfUser',
    send: '/Prescription/Send',
    cancel: '/Prescription/Cancel',
    detail: '/Prescription/Detail',
    getAllPrescriptions: '/Prescription/GetAllPrescription',
    // PrescriptionResponseStateEnum.Accept
    acceptedPrescriptions: '/Prescription/GetAllPrescription?state=2',
    goToPayment: '/Prescription/GoToPayment',
    checkPharmacyCode: '/Prescription/CheckPharmacyCode?code=',
    edit: '/Prescription/EditByAdmin',
  }

  getList = async (
    skip: number,
    top: number = 10,
    filterPrescription: number = -1,
    searchableColumns: DataTableColumns[] = [],
    searchText: string = '',
  ): Promise<any> => {
    var filter = 'true'
    if (searchText.trim() != '') {
      filter += `and (contains(cast(comment,'Edm.String'),'${searchText}'))`
    }
    const result = await this.postJsonData(
      `${this.urls.getList}?state=${filterPrescription}&$top=${top}&$skip=${
        skip * top
      }&$orderby=id desc&$filter=${filter}`,
    )
    return result.data
  }

  getPrescriptionsCount = async (): Promise<any> => {
    const result = await this.postJsonData(
      `${this.urls.getList}?$filter=cancelDate eq null ` +
        `and expireDate gt now() `,
    )
    return result.data.items.length
  }

  getPrescriptionOfUser = async (
    skip: number,
    top: number = 10,
  ): Promise<any> => {
    const result = await this.postJsonData(`${this.urls.getPrescriptionOfUser}`)
    return result.data
  }

  detail = async (id: number): Promise<any> => {
    const result = await this.postJsonData(`${this.urls.detail}/${id}`)
    return result.data
  }

  cancel = async (id: number): Promise<any> => {
    const result = await this.postJsonData(
      `${this.urls.cancel}?prescriptionID=${id}`,
    )
    return result.data
  }

  save = async (data: PrescriptionResponseInterface): Promise<any> => {
    const { prescriptionID, isAccept, pharmacyComment } = data
    const result = await this.postJsonData(
      `${this.urls.save}?prescriptionID=${prescriptionID}` +
        `&isAccept=${isAccept}&pharmacyComment=${pharmacyComment}`,
    )
    return result.data
  }

  send = async (data: PrescriptionSendInterface): Promise<any> => {
    const result = await this.postFormData(
      `${this.urls.send}?duration=${data.duration}` +
        `&contryDivisionCode=${data.contryDivisionCode}` +
        `&isSath1=${data.isSath1}` +
        `&isSath2=${data.isSath2}` +
        `&isSath3=${data.isSath3}` +
        `&nationalCode=${data.nationalCode}` +
        `&peygiriCode=${data.peygiriCode}` +
        `&pharmacyCode=${data.pharmacyCode}` +
        '&callBackUrlToApp=https://tabadol.daroog.net/%23/dashboard/peopleSection/prescription',
      { file: data.file, comment: data.comment },
    )
    return result.data
  }

  edit = async (data: PrescriptionEditInterface): Promise<any> => {
    const result = await this.postFormData(
      `${this.urls.edit}?` +
        `prescriptionId=${data.prescriptionId}` +
        `&duration=${data.duration}` +
        `&contryDivisionCode=${data.contryDivisionCode}` +
        `&isSath1=${data.isSath1}` +
        `&isSath2=${data.isSath2}` +
        `&isSath3=${data.isSath3}` +
        `&nationalCode=${data.nationalCode}` +
        `&peygiriCode=${data.peygiriCode}` +
        `&cost=${data.cost}` +
        `&state=${data.state}`,
      { file: data.file, comment: data.comment },
    )
    return result.data
  }

  checkPharmacyCode = async (code: string): Promise<any> => {
    try {
      const result = await this.postData(this.urls.checkPharmacyCode + code)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getAllPrescriptions = async (
    state: PrescriptionResponseStateEnum | null = null,
  ): Promise<any> => {
    const result = await this.postJsonData(
      `${this.urls.getAllPrescriptions}?state=${state}`,
    )
    return result.data
  }

  goToPayment = async (prescriptionID: number): Promise<any> => {
    const result = await this.postJsonData(
      `${this.urls.goToPayment}?prescriptionID=${prescriptionID}` +
        '&callBackUrlToApp=https://tabadol.daroog.net/%23/dashboard/peopleSection/prescription' +
        `&bankGetway=zarinpal`,
    )

    return result.data
  }
}

export default Prescription
